/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconMenu3 = createReactComponent("outline", "menu-3", "IconMenu3", [["path", { "d": "M10 6h10", "key": "svg-0" }], ["path", { "d": "M4 12h16", "key": "svg-1" }], ["path", { "d": "M7 12h13", "key": "svg-2" }], ["path", { "d": "M4 18h10", "key": "svg-3" }]]);

export { IconMenu3 as default };
//# sourceMappingURL=IconMenu3.mjs.map
